import React, { useState } from 'react';

import { Box, Button, Flex, Text } from '@rover/kibble/core';
import Modal from '@rover/kibble/official-patterns/Modal';
import type { SearchScoreDebugData } from '@rover/types/src/SearchScoreDebugData';

import { SEARCH_RESULT_CARD_Z_INDEX } from './SearchResultCard.constants';

export type Props = {
  data: SearchScoreDebugData[];
};

const SearchScoreData = ({ data = [] }: Props): React.ReactElement => {
  const [isDebugModalOpen, setIsDebugModalOpen] = useState(false);

  return (
    <>
      <Modal
        headerText="Search Score Data"
        isOpen={isDebugModalOpen}
        onRequestClose={() => setIsDebugModalOpen(false)}
        submitButtonText="Close"
        onClickSubmit={() => setIsDebugModalOpen(false)}
      >
        <Flex flexDirection="column">
          {data.map(([key, value]) => (
            <Flex key={key} justifyContent="space-between" alignItems="center">
              <Text fontWeight="semibold" marginRight="1x">
                {key}:
              </Text>
              <Text>{`${value}`}</Text>
            </Flex>
          ))}
        </Flex>
      </Modal>
      <Box zIndex={SEARCH_RESULT_CARD_Z_INDEX.INTERACTIVE.toString()} position="relative">
        <Button size="small" my="2x" onPress={() => setIsDebugModalOpen(true)}>
          Search Score Data
        </Button>
      </Box>
    </>
  );
};

export default SearchScoreData;
